module.exports = __webpack_public_path__ + "media/mlp.034a238a.mp4";